import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

class GetUserAsignRecord {
  constructor() {
    this.cache = new Map();
    this.pendingRequests = new Map();
  }

  clearCache() {
    this.cache.clear();
  }

  async callGetUserAsignRecord(payload) {
    const key = JSON.stringify(payload);

    if (this.cache.has(key)) {
      return this.cache.get(key);
    }

    if (this.pendingRequests.has(key)) {
      // await data response
      try {
        const response = await this.pendingRequests.get(key);
        this.cache.set(key, response);
        this.pendingRequests.delete(key);
        return response;
      } catch (error) {
        console.log(error.response.data.error);
        this.pendingRequests.delete(key);
        throw error;
      }
    }

    this.pendingRequests.set(key, this.fetchData());

    try {
      const response = await this.pendingRequests.get(key);
      this.cache.set(key, response);
      this.pendingRequests.delete(key);
      return response;
    } catch (error) {
      console.log(error.response.data.error);
      this.pendingRequests.delete(key);
      throw error;
    }
  }

  async fetchData() {
    const isTokenValid = await checkTokenExpiration();
    return axios.get(BASE_URL_API + "user/get-user-assign-record-to", {
      headers: {
        Authorization: isTokenValid,
      },
    });
  }
}

const getUserAsignRecordService = new GetUserAsignRecord();

export default getUserAsignRecordService;
